import styled from "styled-components";

export const Container = styled.section`
  margin-top: 10rem;

  header {
    text-align: center;

    h2 {
      text-align: center;
      font-size: 4rem;
    }

    p {
      color: var(--green);
      font-weight: 500;
    }
  }

  .contacts {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 2rem;
  }

  .contact-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.4rem;
    padding: 1.6rem 2.8rem;
    background-color: var(--green);
    border-radius: 1.4rem;
    text-decoration: none;
    color: var(--black);
    font-weight: 600;
    font-size: 1.8rem;
    width: 100%;
    max-width: 30rem;
    transition: background-color 0.3s ease, color 0.3s ease;

    img {
      width: 3.2rem;
      height: 3.2rem;
      object-fit: contain;
    }

    &:hover {
      background-color: var(--pink);
      color: var(--green);

      span {
        color: var(--green);
      }
    }
  }

  @media (max-width: 960px) {
    .contacts {
      flex-direction: column;
    }

    .contact-button {
      width: 100%;
    }
  }
`;
